import { useQuery } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";

export type CandidateSkillScope = "mine" | "team";

export interface CandidateSkillOption {
  id: number;
  name: string;
}

const ENDPOINTS: Record<CandidateSkillScope, string> = {
  mine: "/candidates/skills",
  team: "/team/candidates/skills",
};

/**
 * Distinct skills attached to the recruiter's own (or their team's) candidates,
 * used to populate the candidate list skills filter.
 */
export default function useCandidateSkillOptions(scope: CandidateSkillScope) {
  const api = useAxios();

  const { data, isLoading } = useQuery({
    queryKey: ["candidate-skill-options", scope],
    queryFn: () => api.get(ENDPOINTS[scope]),
    staleTime: 60 * 1000,
    throwOnError: false,
  });

  const skills: CandidateSkillOption[] = data?.data ?? [];

  return { skills, isLoading };
}
